import React,{Component} from 'react';
import authClient from '../../sdk/api'
import PropTypes from 'prop-types';
import _ from "lodash";
import {getToken} from "../shared/TokenInformation/TokenInformation"
import { useNavigate } from 'react-router-dom';
/**
 * React component for managing the return entry point of the implicit OAuth 2.0 flow and is expecting "access_token", "id_token" or "code" in a redirect uri.
 * The user will be redirected to this point based on the redirect_uri in pingOneAuthConfig.js - the URL that specifies the return entry point of this application.
 */
function withNavigate(Component) {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}




class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      access_token: null,
      id_token: null,
      idTokenJson: null,
      userInfo: null,
      errorMessage: '',
      loggedIn : false
    }

    this.handleSignIn = this.handleSignIn.bind(this);
    this.handleSignOff = this.handleSignOff.bind(this);
  }
 
  handleSignIn() {
    let state = authClient.generateRandomValue();
    let nonce = authClient.generateRandomValue();
    // Store state and nonce parameters into the session, so we can retrieve them after
    // user will be redirected back with access token or code (since react state is cleared in this case)
    sessionStorage.setItem("state", state);
    sessionStorage.setItem("nonce", nonce);
    authClient.authorize(state, nonce); 
  }

  handleSignOff() {
    if (this.state.id_token) {
      authClient.signOff(this.state.id_token, sessionStorage.getItem("state"));
    }
    this.clearSession();
  }

  clearSession() {
    // Run Local 
    this.setState({
      access_token: null,
      id_token: null,
      errorMessage: '',
      loggedIn : true
    });
  }

  componentDidMount() {
    
    //handle redirect from auth provider
    const hashes = authClient.parseHash();
    if (hashes.error && hashes.error_description) { 
      this.setState({
        errorMessage: hashes.error + ': ' + hashes.error_description,
      });
      return;
    }

    const stateMatch = window.location.href.match('[?#&]state=([^&]*)');
    if (stateMatch && !stateMatch[1] &&
        !_.isEqual(stateMatch[1], sessionStorage.getItem("state"))) {
      this.setState({
        errorMessage: "State parameter mismatch. "
      });
      this.clearSession();
      return;
    }

    const codeMatch = window.location.href.match('[?#&]code=([^&]*)');
    // Authorization code flow: access code is present in URL
    if (codeMatch && codeMatch[1]) {
      authClient.getAccessToken(codeMatch[1])
      .then(tokenInfo => {
        let expiresAt = new Date().getTime();
        expiresAt = expiresAt + (tokenInfo.expires_in * 1000);
        tokenInfo.expires_in = expiresAt;
        sessionStorage.setItem("TokenInfo", JSON.stringify(tokenInfo));
        this.setState({
          //access_token: tokenInfo.jwt_token
          access_token:tokenInfo.access_token,
          loggedIn : true,
          userInfo : tokenInfo.username
        });
        // Replace current URL without adding it to history entries
        window.history.replaceState({}, '', '/');
        //redirecting cost-upload page
        this.redirectToCostUpload();
      })
      .catch(error => {
        this.setState({
          errorMessage: "Couldn't get an access token. " + _.get(error,
              'error_description', _.get(error, 'message', ''))
        })
      }); 
      
    } 
    
    const tokenInfo = getToken();
    //if valid token not found or first time rendoring for the session
    if (!codeMatch && !tokenInfo) {
      this.handleSignIn();
      return;
    } 

    //if token is available
    if (tokenInfo && tokenInfo.access_token) {
      this.redirectToCostUpload();
      return;
    }
  }
  
  redirectToCostUpload(){
    
   this.props.navigate("/cjw-Upload")
   //window.location.href = "/cost-upload";
   //nav("/cost-upload")
  }

  render() {
   const { loggedIn, errorMessage} = this.state;
    const errorMsg = errorMessage && (
        <div className="alert alert-danger">{errorMessage}</div>
    );

    return (
      <div className="container">
        {errorMsg}
        {loggedIn ? "Redirecting to CostUpload Page...." : "Redirecting to SignOn Page...."}
      </div>
  )
  } 
}

Home.propTypes = {
   environmentId: PropTypes.string.isRequired,
   clientId: PropTypes.string.isRequired,
   scope: PropTypes.string.isRequired,
  responseType: PropTypes.string,
  tokenEndpointAuthMethod: PropTypes.string.isRequired,
  grantType: PropTypes.string,
  prompt: PropTypes.string,
  redirectUri: PropTypes.string,
  logoutRedirectUri: PropTypes.string,
  maxAge: PropTypes.number
}; 

export default withNavigate(Home);